"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyAccountHeader = function MyAccountHeader(_ref) {
  var isMemberApp = _ref.isMemberApp,
      userName = _ref.userName,
      globalLinksURL = _ref.globalLinksURL,
      signout = _ref.signout;

  // Cap the count to 15 characters
  if (userName && userName.length > 15) {
    userName = userName.substring(0, 15) + '...';
  }

  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.DropdownButton, {
    variant: "primary",
    alignRight: true,
    className: "profileOptionMenu",
    bsPrefix: "astm-btn astm-btn--small btn-primary",
    title: /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "usernameBtn"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fas fa-user-circle mr5 astm-icon"
    }), /*#__PURE__*/_react.default.createElement("span", null, userName)),
    id: "dropdown-menu-align-right"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "1",
    href: globalLinksURL.profile
  }, "MyAccount"), isMemberApp ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "2",
    as: _reactRouterDom.Link,
    to: globalLinksURL.membership
  }, "Membership"), globalLinksURL.myCommitteesUrl && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "3",
    as: _reactRouterDom.Link,
    to: globalLinksURL.myCommitteesUrl
  }, "MyCommittees")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "2",
    href: globalLinksURL.membership
  }, "Membership"), globalLinksURL.myCommitteesUrl && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "3",
    href: globalLinksURL.myCommitteesUrl
  }, "MyCommittees")), globalLinksURL.meetingsSymposia && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "4",
    href: globalLinksURL.meetingsSymposia
  }, "Meetings & Symposia"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "5",
    href: globalLinksURL.orders
  }, "Orders"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "6",
    href: globalLinksURL.compass
  }, "Compass"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "7",
    href: globalLinksURL.tracker
  }, "Tracker"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "8",
    href: globalLinksURL.elearning
  }, "eLearning"), globalLinksURL.specbuilder && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "9",
    href: globalLinksURL.specbuilder
  }, "SpecBuilder"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Divider, null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    as: "button",
    eventKey: "10",
    onClick: signout
  }, "Sign Out"));
};

var _default = MyAccountHeader;
exports.default = _default;
